module.exports = __webpack_public_path__ + "static/src/nrl-teams/images/storm.b70a4e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/nrl-teams/images/storm.png
// module id = eF6N
// module chunks = 0